const ApiAttributesKeys = {
  chapterIdKey: 'chapter_id',
  chapterNameKey: 'chapter_name',
  videoTableKey: 'frm_videos',
  videoTitleKey: 'title',
  youtubeIdKey: 'url_id',
  videoTableNameKey: 'frm_videos',
  mockIdKey: 'mock_id',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Videos/PlayList/ApiAttributesKays.js